import React, { useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { toggleGradientColoring } from "../../store/pointsSlice";
import { getGradientMax } from "../../utils/co2";
import "./GradientControl.css";

const GradientControl = () => {
    const dispatch = useDispatch();
    const showGradient = useSelector(
        (state) => state.points.showGradientColoring
    );
    const points = useSelector((state) => state.points.points);
    const gradientMax = useMemo(() => getGradientMax(points), [points]);

    return (
        <div className="gradient-control">
            <label className="gradient-toggle">
                <input
                    type="checkbox"
                    checked={showGradient}
                    onChange={() => dispatch(toggleGradientColoring())}
                />
                Градиент поглощения CO₂
            </label>
            {showGradient && (
                <div className="gradient-legend">
                    <div className="gradient-bar"></div>
                    <div className="gradient-labels">
                        <span>0</span>
                        <span>
                            {gradientMax.toLocaleString("ru-RU")} тыс. т
                        </span>
                    </div>
                </div>
            )}
        </div>
    );
};

export default GradientControl;
